import React from "react";
import { Button, ModalBody } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { handleKeyDown } from "../../../Common/FewCommonMethods";
import { price2validation } from "../../../Common/commonvalidation";

export default function ModelBudgetFromTo({
  price,
  price2,
  setModalBudget,
  hitApi,
  handleInputBudget,
  handleInputBudget2,
}) {
  const initialValues = {
    price: price || "",
    price2: price2 || "",
  };

  const validationSchema = Yup.object().shape({
    price: Yup.number()
      .required("This field is required")
      .positive("Price must be a positive number")
      .typeError("Price must be a number"),
    price2: price2validation,
  });

  const handleSubmit = (values) => {
    setModalBudget(false);
    hitApi(values); // Assuming you want to pass the values to the API call
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue }) => (
        <Form>
          <button
            type="button"
            onClick={() => setModalBudget(false)}
            className ="btn close-button d-block"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt="Close"
            />
          </button>
          <ModalBody>
            <h4>Edit Budget in $</h4>
            <div className ="form-group">
              <div className ="row" >
                <div className ="form-group col-md-6">
                  <label>From Budget</label>
                  <Field
                    className ="form-control input"
                    name="price"
                    placeholder="From Price"
                    onKeyDown={handleKeyDown}
                    onChange={handleInputBudget}
                  />
                  <ErrorMessage name="price" component="div" className ="error" />
                </div>
                <div className ="form-group col-md-6">
                  <label>To Budget</label>
                  <Field
                    className ="form-control input"
                    name="price2"
                    placeholder="To Price"
                    onKeyDown={handleKeyDown}
                    onChange={handleInputBudget2}
                  />
                  <ErrorMessage name="price2" component="div" className ="error" />
                </div>
              </div>
            </div>
          </ModalBody>
          <div className ="modal-footer">
            <Button className ="btn" type="submit">
              Save
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
